/**
 * MM branch inventory: Liquid JSON (store_availabilities) + live qty from /variants/{id}.js
 * 
 * IMPORTANT: store_availabilities in Shopify have delayed propagation (can take hours 
 * after inventory changes). The Liquid JSON embedded in the page is the most current 
 * source. This JS refreshes quantity data via /variants/{id}.js for urgency strips.
 */
(function () {
  function readLabels(root) {
    return {
      available: root.getAttribute('data-mm-inv-available') || 'Available',
      unavailable: root.getAttribute('data-mm-inv-unavailable') || 'Unavailable',
      allLocations: root.getAttribute('data-mm-inv-all-locations') || 'In stock at all locations',
      oneBranchHint:
        root.getAttribute('data-mm-inv-one-branch') ||
        'In stock at one listed location only — see branches below',
      urgency: root.getAttribute('data-mm-inv-urgency') || 'Order soon — selling fast!',
      remaining: root.getAttribute('data-mm-inv-remaining') || 'Only',
      instock: root.getAttribute('data-mm-inv-instock') || 'In stock',
    };
  }

  function findPayloadScript(root) {
    var host = root.closest(
      '.mmshop-card, .mms-card, .mmh-product, .mm-cart-item, .mm-cart-sheet__item, .mmupi-container, .mmpdp-v2'
    );
    if (host) {
      var s = host.querySelector('script.mm-inv-payload[type="application/json"]');
      if (s) return s;
    }
    var sec = root.closest('section.mmupi, .mmpdp-v2, .mmx');
    if (sec) {
      var s2 = sec.querySelector('script.mm-inv-payload[type="application/json"]');
      if (s2) return s2;
    }
    return root.querySelector('script.mm-inv-payload[type="application/json"]');
  }

  function parsePayload(root) {
    var s = findPayloadScript(root);
    if (!s || !s.textContent) return null;
    try {
      return JSON.parse(s.textContent.trim());
    } catch (e) {
      return null;
    }
  }

  function getVariantPayload(data, variantId) {
    if (!data) return null;
    var k = String(variantId);
    if (data[k]) return data[k];
    var n = Number(variantId);
    if (!isNaN(n) && data[String(n)]) return data[String(n)];
    return null;
  }

  function isCartInventoryRoot(root) {
    return (
      root.classList.contains('mm-inv--cart-item-detail') || root.classList.contains('mm-inv--cart-thumb')
    );
  }

  function getCartItemHost(root) {
    return root.closest('.mm-cart-item, .mm-cart-sheet__item');
  }

  function isPayloadLoading(root) {
    var host = getCartItemHost(root);
    if (!host) return false;
    var script = host.querySelector('script.mm-inv-payload[type="application/json"]');
    return !!(script && script.getAttribute('data-mm-inv-loading') === '1');
  }

  function render(root, variantId, freshQty) {
    var data = parsePayload(root);
    var mount = root.querySelector('.mm-inv-mount');
    if (!mount || !data) return;

    var v = getVariantPayload(data, variantId);
    if (!v) {
      mount.innerHTML = '';
      return;
    }

    var labels = readLabels(root);
    var branches = Array.isArray(v.b) ? v.b : [];
    var cartSurface = isCartInventoryRoot(root);
    var loading = isPayloadLoading(root);

    if (cartSurface && loading) {
      mount.innerHTML = '';
      return;
    }

    var q =
      freshQty != null && typeof freshQty === 'number' && !isNaN(freshQty)
        ? freshQty
        : v.q != null && typeof v.q === 'number'
          ? v.q
          : null;

    mount.innerHTML = '';
    var frag = document.createDocumentFragment();
    var shopListing = root.classList.contains('mm-inv--shop-below');
    var cartItemDetail = root.classList.contains('mm-inv--cart-item-detail');

    if (cartItemDetail || root.classList.contains('mm-inv--cart-thumb') || root.classList.contains('mm-inv--inline-variant') || root.classList.contains('mm-inv--gallery')) {
      mount.classList.add('mm-inv-mount--compact');
    }

    if (branches.length > 0 && !shopListing) {
      var pdpV2 = root.closest('.mmpdp-v2');
      if (pdpV2) {
        var list = document.createElement('div');
        list.className = 'mmpdp-v2-inv';
        branches.forEach(function (b) {
          var inStock = !!b.a;
          var row = document.createElement('div');
          row.className = 'mmpdp-v2-inv__row' + (inStock ? ' is-in' : ' is-out');
          var nameEl = document.createElement('span');
          nameEl.className = 'mmpdp-v2-inv__name';
          nameEl.textContent = localizeBranchName(b.n || '');
          var statusEl = document.createElement('span');
          statusEl.className = 'mmpdp-v2-inv__status';
          statusEl.textContent = inStock ? labels.instock : labels.unavailable;
          row.appendChild(nameEl);
          row.appendChild(statusEl);
          list.appendChild(row);
        });
        frag.appendChild(list);
      } else {
        var chips = document.createElement('div');
        chips.className = 'mm-inv-chips';
        var yesMark = root.getAttribute('data-mm-inv-pickup-yes') || '✓';
        var noMark = root.getAttribute('data-mm-inv-pickup-no') || '✗';
        branches.forEach(function (b) {
          var chip = document.createElement('span');
          chip.className = 'mm-inv-chip' + (b.a ? ' mm-inv-chip--yes' : ' mm-inv-chip--no');
          var shortName = localizeBranchName(b.n || '');
          chip.textContent = shortName + ' ' + (b.a ? yesMark : noMark);
          chip.title =
            shortName + ': ' + (b.a ? labels.available : labels.unavailable);
          chips.appendChild(chip);
        });
        frag.appendChild(chips);
      }
    } else if (branches.length > 0) {
      var anyAvailable = branches.some(function (b) {
        return b.a;
      });
      var shopRow = document.createElement('div');
      shopRow.className = 'mm-inv-row' + (anyAvailable ? '' : ' mm-inv-oos-only');
      shopRow.textContent = anyAvailable ? labels.instock : labels.unavailable;
      frag.appendChild(shopRow);
    } else {
      if (cartSurface) {
        mount.innerHTML = '';
        return;
      }
      var row = document.createElement('div');
      row.className = 'mm-inv-row' + (v.av ? '' : ' mm-inv-oos-only');
      if (v.av) {
        var ok = document.createElement('span');
        ok.className = 'mm-inv-yes';
        ok.textContent = labels.instock;
        row.appendChild(ok);
      } else {
        row.textContent = labels.unavailable;
      }
      frag.appendChild(row);
    }

    if (!shopListing && !cartItemDetail && q != null && q > 0 && q < 10) {
      var urg = document.createElement('div');
      urg.className = 'mm-inv-urgency';
      urg.innerHTML =
        '<span class="mm-inv-urg-icon" aria-hidden="true">⚡</span><span>' +
        labels.urgency +
        ' — ' +
        labels.remaining +
        ' ' +
        q +
        '</span>';
      frag.appendChild(urg);
    }

    mount.appendChild(frag);
  }

  function rootsMatchingVariant(variantId) {
    var want = String(variantId);
    return Array.prototype.filter.call(document.querySelectorAll('.mm-inv-root'), function (el) {
      return String(el.getAttribute('data-variant-id')) === want;
    });
  }

  var inFlightVariantFetches = {};

  function refreshFromApi(root, variantId) {
    if (isPayloadLoading(root)) return;
    render(root, variantId, null);
    var id = parseInt(variantId, 10);
    if (!id) return;
    var key = String(id);

    function applyQty(qty) {
      rootsMatchingVariant(variantId).forEach(function (el) {
        render(el, variantId, qty);
      });
    }

    if (inFlightVariantFetches[key]) {
      inFlightVariantFetches[key].then(function (qty) {
        applyQty(qty);
      });
      return;
    }

    inFlightVariantFetches[key] = fetch('/variants/' + id + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('variant');
        return r.json();
      })
      .then(function (vr) {
        var qty =
          typeof vr.inventory_quantity === 'number' && !isNaN(vr.inventory_quantity)
            ? vr.inventory_quantity
            : null;
        applyQty(qty);
        return qty;
      })
      .catch(function () {
        applyQty(null);
        return null;
      })
      .finally(function () {
        delete inFlightVariantFetches[key];
      });
  }

  /**
   * Switch a shop/mobile card's inventory display to show a specific variant's branch data.
   * If variantId is empty/falsy, revert to product-level display ("_product_").
   */
  function updateShopCard(cardEl, variantId) {
    if (!cardEl) return;
    var vid = variantId && variantId !== '' && variantId !== '0' ? String(variantId) : '_product_';
    cardEl.querySelectorAll('.mm-inv-root').forEach(function (el) {
      el.setAttribute('data-variant-id', vid);
      if (vid === '_product_') {
        render(el, vid, null);
      } else {
        var data = parsePayload(el);
        var vData = getVariantPayload(data, vid);
        if (vData && vData.b && vData.b.length > 0) {
          render(el, vid, null);
        } else {
          refreshFromApi(el, vid);
        }
      }
    });
  }

  function escapeHtml(str) {
    var d = document.createElement('div');
    d.textContent = str == null ? '' : String(str);
    return d.innerHTML;
  }

  function shortBranchName(name) {
    if (!name) return '';
    return String(name)
      .replace(/\s*(branch|store|فرع)\s*$/i, '')
      .trim();
  }

  function getBranchLabelMap() {
    if (window.__MM_BRANCH_LABELS__) return window.__MM_BRANCH_LABELS__;
    return { jidhafs: 'Jidhafs', jerdab: 'Jerdab' };
  }

  function localizeBranchName(name) {
    var core = shortBranchName(name).toLowerCase().replace(/[^a-z0-9\u0600-\u06ff]/g, '');
    var map = getBranchLabelMap();
    if (core.indexOf('jidhaf') !== -1) return map.jidhafs || 'Jidhafs';
    if (core.indexOf('jerdab') !== -1 || core.indexOf('jardab') !== -1) {
      return map.jerdab || 'Jerdab';
    }
    return shortBranchName(name);
  }

  function readCompactPickupLabels(root) {
    var labels = readPickupLabels(root);
    return {
      heading: labels.title || labels.heading || 'Branch pickup',
      unavailableAt: labels.unavailableAt || 'Not at',
      yes: labels.yes || '✓',
      no: labels.no || '✗',
    };
  }

  function apiRoot() {
    if (window.Shopify && window.Shopify.routes && typeof window.Shopify.routes.root === 'string') {
      var r = window.Shopify.routes.root;
      return r.slice(-1) === '/' ? r : r + '/';
    }
    return '/';
  }

  var branchPayloadCache = {};

  function fetchBranchPayload(handle, variantId) {
    if (!handle) return Promise.resolve(null);
    var key = handle + ':' + (variantId || '');
    if (branchPayloadCache[key]) return branchPayloadCache[key];
    var url =
      apiRoot() + 'products/' + encodeURIComponent(handle) + '?view=branch-inventory';
    if (variantId) url += '&variant=' + encodeURIComponent(variantId);
    branchPayloadCache[key] = fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('branch-inventory');
        return r.text();
      })
      .then(function (text) {
        try {
          return JSON.parse(text.trim());
        } catch (e) {
          return null;
        }
      })
      .catch(function () {
        return null;
      });
    return branchPayloadCache[key];
  }

  function getCartItemHosts(scope) {
    var root = scope || document;
    return Array.prototype.slice.call(root.querySelectorAll('.mm-cart-item, .mm-cart-sheet__item'));
  }

  function getItemTitle(host) {
    var t = host.querySelector('.mm-item-title, .mm-cart-sheet__item-title');
    return t ? t.textContent.trim() : 'Item';
  }

  function getItemVariantId(host) {
    var vid = host.getAttribute('data-variant-id');
    if (vid) return vid;
    var inv = host.querySelector('.mm-inv-root[data-variant-id]');
    return inv ? inv.getAttribute('data-variant-id') : null;
  }

  function readPickupLabels(scope) {
    var notice = (scope || document).querySelector('[data-mm-pickup-labels]');
    if (!notice) {
      return {
        unavailableAt: 'Not at',
        yes: '✓',
        no: '✗',
      };
    }
    try {
      return JSON.parse(notice.getAttribute('data-mm-pickup-labels'));
    } catch (e) {
      return {
        unavailableAt: 'Not at',
        yes: '✓',
        no: '✗',
      };
    }
  }

  function analyzeCartPickupIssues(scope) {
    var byProduct = {};
    getCartItemHosts(scope).forEach(function (host) {
      var vid = getItemVariantId(host);
      if (!vid) return;
      var script = host.querySelector('script.mm-inv-payload[type="application/json"]');
      if (!script || !script.textContent || script.getAttribute('data-mm-inv-loading') === '1') return;
      var data;
      try {
        data = JSON.parse(script.textContent.trim());
      } catch (e) {
        return;
      }
      var v = getVariantPayload(data, vid);
      if (!v || !Array.isArray(v.b) || !v.b.length) return;
      var title = getItemTitle(host);
      v.b.forEach(function (branch) {
        if (branch.a) return;
        var shortName = localizeBranchName(branch.n || 'Branch');
        if (!byProduct[title]) byProduct[title] = [];
        if (byProduct[title].indexOf(shortName) === -1) byProduct[title].push(shortName);
      });
    });
    return byProduct;
  }

  function analyzeCartBranchIssues(scope) {
    return analyzeCartPickupIssues(scope);
  }

  function renderPickupNotice(scope) {
    var root = scope || document;
    root.querySelectorAll('#mmBranchPickupNotice, [data-mm-pickup-notice]').forEach(function (notice) {
      var byProduct = analyzeCartPickupIssues(root);
      var productTitles = Object.keys(byProduct);
      if (!productTitles.length) {
        notice.hidden = true;
        notice.innerHTML = '';
        return;
      }

      var labels = readCompactPickupLabels(root);
      var rows = '';
      var ariaParts = [];

      productTitles.forEach(function (title) {
        var branches = byProduct[title];
        if (!branches.length) return;
        rows +=
          '<li class="mm-branch-pickup-notice__row">' +
          '<span class="mm-branch-pickup-notice__product">' +
          escapeHtml(title) +
          '</span>' +
          '<span class="mm-branch-pickup-notice__meta">' +
          escapeHtml(labels.unavailableAt) +
          ' ' +
          branches.map(escapeHtml).join(', ') +
          '</span></li>';
        ariaParts.push(title + ' — ' + labels.unavailableAt + ' ' + branches.join(', '));
      });

      notice.innerHTML =
        '<div class="mm-branch-pickup-notice__inner">' +
        '<p class="mm-branch-pickup-notice__heading">' +
        '<span class="mm-branch-pickup-notice__icon" aria-hidden="true">⚠</span> ' +
        escapeHtml(labels.heading || labels.unavailableAt || 'Pickup') +
        '</p>' +
        '<ul class="mm-branch-pickup-notice__rows">' +
        rows +
        '</ul></div>';
      notice.setAttribute('aria-label', ariaParts.join('. '));
      notice.hidden = false;
    });
  }

  function hydrateCartItemBranch(host) {
    if (!host) return Promise.resolve();
    var handle = host.getAttribute('data-product-handle');
    var vid = getItemVariantId(host);
    if (!handle || !vid) return Promise.resolve();

    var script = host.querySelector('script.mm-inv-payload[type="application/json"]');
    if (!script) return Promise.resolve();
    if (script.textContent && script.getAttribute('data-mm-inv-loading') !== '1') {
      host.querySelectorAll('.mm-inv-root').forEach(function (el) {
        el.setAttribute('data-variant-id', vid);
        render(el, vid, null);
      });
      return Promise.resolve();
    }

    return fetchBranchPayload(handle, vid).then(function (data) {
      if (!data) {
        script.removeAttribute('data-mm-inv-loading');
        return;
      }
      script.textContent = JSON.stringify(data);
      script.removeAttribute('data-mm-inv-loading');
      host.querySelectorAll('.mm-inv-root').forEach(function (el) {
        el.setAttribute('data-variant-id', vid);
        render(el, vid, null);
      });
    });
  }

  function hydrateCartItems(cart, scope) {
    var ctx = scope || document;
    var hosts = getCartItemHosts(ctx);
    if (!hosts.length) {
      renderPickupNotice(ctx);
      return Promise.resolve();
    }

    return Promise.all(
      hosts.map(function (host) {
        return hydrateCartItemBranch(host);
      })
    ).then(function () {
      renderPickupNotice(ctx);
    });
  }

  function updateCartNotice(scope) {
    renderPickupNotice(scope || document);
  }

  window.MMBranchInventory = {
    init: function (context) {
      var root = context || document;
      root.querySelectorAll('.mm-inv-root').forEach(function (el) {
        var vid = el.getAttribute('data-variant-id');
        if (vid) refreshFromApi(el, vid);
      });
    },
    updateCard: function (cardEl, variantId) {
      if (!cardEl || !variantId) return;
      cardEl.querySelectorAll('.mm-inv-root').forEach(function (el) {
        el.setAttribute('data-variant-id', variantId);
        refreshFromApi(el, variantId);
      });
    },
    updateShopCard: updateShopCard,
    updateProductPage: function (variantId) {
      if (!variantId) return;
      document.querySelectorAll('section.mmupi .mm-inv-root, .mmpdp-v2 .mm-inv-root, .mmx .mm-inv-root').forEach(function (el) {
        el.setAttribute('data-variant-id', variantId);
        var sec = el.closest('section.mmupi, .mmpdp-v2, .mmx');
        var handle = el.getAttribute('data-product-handle');
        var script = sec ? sec.querySelector('script.mm-inv-payload[type="application/json"]') : null;

        function applyPayload(data) {
          if (script && data) {
            script.textContent = JSON.stringify(data);
            script.removeAttribute('data-mm-inv-loading');
          }
          render(el, variantId, null);
          refreshFromApi(el, variantId);
        }

        if (handle) {
          fetchBranchPayload(handle, variantId).then(applyPayload);
        } else {
          applyPayload(null);
        }
      });
    },
    updateGallery: function (variantId) {
      window.MMBranchInventory.updateProductPage(variantId);
    },
    hydrateCartItems: hydrateCartItems,
    updateCartNotice: updateCartNotice,
  };

  function bootMmBranchInventory(scope) {
    var ctx = scope || document;
    hydrateCartItems(null, ctx).then(function () {
      window.MMBranchInventory.init(ctx);
      var vidInput = document.getElementById('mmupiVariantId') || document.getElementById('mmpdp-v2-variant-id');
      if (vidInput && vidInput.value) {
        window.MMBranchInventory.updateProductPage(String(vidInput.value));
      }
    });
  }

  function scheduleMmBranchInventoryBoot(scope) {
    bootMmBranchInventory(scope);
    setTimeout(function () {
      bootMmBranchInventory(scope);
    }, 0);
    setTimeout(function () {
      bootMmBranchInventory(scope);
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleMmBranchInventoryBoot(document);
    });
  } else {
    scheduleMmBranchInventoryBoot(document);
  }

  window.addEventListener('load', function () {
    bootMmBranchInventory(document);
  });

  window.addEventListener('pageshow', function (ev) {
    if (ev.persisted) scheduleMmBranchInventoryBoot(document);
  });

  if ('onpagereveal' in window) {
    window.addEventListener('pagereveal', function () {
      scheduleMmBranchInventoryBoot(document);
    });
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var t = ev.target;
    if (t && t.nodeType === 1 && typeof t.querySelector === 'function' && t.querySelector('.mm-inv-root')) {
      scheduleMmBranchInventoryBoot(t);
    }
  });

  document.addEventListener('cart:updated', function () {
    var sheet = document.getElementById('mmCartSheet');
    hydrateCartItems(null, sheet || document);
  });
})();
